import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Actor from '../../../domain/entities/Actor';

export default function reducer(
  state: {[key: number]: Actor} = {},
  action: AnyAction,
): {[key: number]: Actor} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexActorsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Actor}, record: Actor) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowActorSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
